"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var UserReports = /*#__PURE__*/function () {
  function UserReports(client) {
    (0, _classCallCheck2["default"])(this, UserReports);
    this.client = client;
    this.resourceUrl = '/document';
  }

  (0, _createClass2["default"])(UserReports, [{
    key: "getDownloadDocumentUrl",
    value: function getDownloadDocumentUrl(clientId, documentId, type, documentName, contentType) {
      for (var _len = arguments.length, args = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(documentId, "/").concat(type, "/signed-url?fileType=").concat(contentType, "&fileName=").concat(documentName), args);
    }
  }]);
  return UserReports;
}();

exports["default"] = UserReports;